module.exports = __webpack_public_path__ + "media/images/cctv-22207ab27c5d01a37512575e5814ef4d.jpg";